import React from "react";
import ObjectUsersBody from "./ObjectUsersBody/ObjectUsersBody";
import ObjectUsersHead from "./ObjectUsersHead/ObjectUsersHead";
import ObjectUsersFooter from "./ObjectUsersFooter/ObjectUsersFooter";

export default function ObjectUsers() {
	const lang = localStorage.getItem("lang") || "en";

	return (
		<>
			<div
				className={`bg-white-rounded p-0 object-users ${
					lang === "en" ? "object-users-ltr" : "object-users-rtl"
				}`}
			>
				<ObjectUsersHead />
				<ObjectUsersBody />
				<ObjectUsersFooter />
			</div>
		</>
	);
}
